'use strict';

// Добавление класса к header в зависимости от скроллинга страницы. Только для главной страницы
(function () {
  let headerSite = document.querySelector('.js-header-sticky');
  if (headerSite) {
    let
      headerSiteHeight = headerSite.clientHeight,
      headerLogo = headerSite.querySelector('.js-logo');
    if (window.matchMedia("(min-width: 480px)").matches) {
      document.addEventListener('scroll', function () {
        let positivePositionAxisY = document.body.getBoundingClientRect().y * (-1);

        if (positivePositionAxisY > headerSiteHeight) {
          headerSite.classList.add('header--sticky');
          headerLogo.classList.remove('my-hidden');
          headerLogo.tabIndex = '0';
        } else {
          headerSite.classList.remove('header--sticky');
          headerLogo.classList.add('my-hidden');
          headerLogo.tabIndex = '-1';
        }
      });
    }

    if (window.matchMedia("(max-width: 480px)").matches) {
      headerSite.classList.add('header--sticky');
      headerLogo.classList.remove('my-hidden');
      headerLogo.tabIndex = '0';
    }
  }

})();

// Зацикливание фокуса для доступности в модалках
(function () {
  const
    MODAL_ELEMENT_FOCUSED = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, [tabindex="0"]',
    MODAL_FOCUS_TRAP_CLASS_NAME = 'js-trap-focus';

  function setFocusTrap(focusWrap) {
    let
      focusedElements = focusWrap.querySelectorAll(MODAL_ELEMENT_FOCUSED),
      firstFocusElement = focusedElements[0],
      lastFocusElement = focusedElements[focusedElements.length - 1],
      defaultFocusElements = focusWrap.querySelectorAll('.' + MODAL_FOCUS_TRAP_CLASS_NAME);

    if (defaultFocusElements.length === 0) {
      let
        createFocusTrap = window.utils.createDivWithClass(MODAL_FOCUS_TRAP_CLASS_NAME),
        cloneCreateFocusTrap = createFocusTrap.cloneNode();

      cloneCreateFocusTrap.setAttribute('tabindex', '0');
      createFocusTrap.setAttribute('tabindex', '0');

      focusWrap.appendChild(createFocusTrap);
      focusWrap.insertAdjacentElement('afterbegin', cloneCreateFocusTrap);

      // Зацикливание фокуса внутри модалки
      let focusTraps = focusWrap.children;

      if (!lastFocusElement) {
        lastFocusElement = focusTraps[focusTraps.length - 1];
      }
      if (!firstFocusElement) {
        firstFocusElement = focusTraps[0];
      }

      firstFocusElement.focus();

      focusTraps[focusTraps.length - 1].addEventListener('focus', function () {
        firstFocusElement.focus();
      });
      focusTraps[0].addEventListener('blur', function () {
        lastFocusElement.focus();
      });
    } else {
      defaultFocusElements.forEach(function (current) {
        current.remove();
      })
    }

  }

  window.focusTrap = {
    setFocusTrap: setFocusTrap
  }

})();

// Инкремент|Дикремент числа в инпуте
(function () {
  const
    NUMBER_PARENT = 'js-numeric',
    NUMBER_INCREMENT = 'js-numeric-plus',
    NUMBER_DECREMENT = 'js-numeric-minus',
    NUMBER_INPUT_TARGET = 'js-numeric-target',
    DEFAULT_NUMBER_MAX = 10,
    DEFAULT_NUMBER_MIN = 0;

  let numericParent = window.utils.getArrayFrom(document.querySelectorAll('.' + NUMBER_PARENT));

  numericParent.forEach(function (current) {
    let
      numIncrementButton = current.querySelector('.' + NUMBER_INCREMENT),
      numDecrementButton = current.querySelector('.' + NUMBER_DECREMENT),
      numTargetInput = current.querySelector('.' + NUMBER_INPUT_TARGET);

    function incrementNumber() {
      let maxValue = +numTargetInput.dataset.maxValue || DEFAULT_NUMBER_MAX;

      if (+numTargetInput.value < maxValue) {
        numTargetInput.value++;
      }
    }

    function decrementNumber() {
      let minValue = +numTargetInput.dataset.minValue || DEFAULT_NUMBER_MIN;

      if (+numTargetInput.value > minValue) {
        numTargetInput.value--;
      }
    }

    numIncrementButton.addEventListener('click', incrementNumber);
    numIncrementButton.addEventListener('keyDown', function (evt) {
      evt.preventDefault();

      if (evt.key === window.utils.keyEnter) {
        incrementNumber();
      }
    });

    numDecrementButton.addEventListener('click', decrementNumber);
    numDecrementButton.addEventListener('keyDown', function (evt) {
      evt.preventDefault();

      if (evt.key === window.utils.keyEnter) {
        decrementNumber();
      }
    });
  });
})();

// Модальное окно
(function () {
  const
    OVERLAY_CLASS_NAME = 'modal-overlay',
    MODAL_BUTTON_CLOSE_CLASS_NAME = 'js-modal-close',
    TRANSITION_TIME = 0.4;

  let createOverModal = window.utils.createDivWithClass(OVERLAY_CLASS_NAME);

  document.body.appendChild(createOverModal);

  let alexModal = function (modal) {
    let
      buttonModalShow = modal,
      modalWindow = document.querySelector(buttonModalShow.dataset.id),
      buttonModalHide = modalWindow.querySelectorAll('.' + MODAL_BUTTON_CLOSE_CLASS_NAME),
      modalOverlay = document.querySelector('.' + OVERLAY_CLASS_NAME),
      body = document.body;

    function openModal() {
      let scrollBarWidth = window.utils.getScrollbarWidth();

      body.classList.add('modal-open');

      body.style.paddingRight = scrollBarWidth + 'px';
      modalWindow.style.paddingRight = scrollBarWidth + 'px';

      modalOverlay.style.display = 'block';
      modalWindow.style.display = 'block';
      setTimeout(function () {
        modalOverlay.classList.add('this-show');

        modalWindow.classList.remove('modal-hidden');
      }, 100);

      document.addEventListener('keydown', documentKeyDownHandler);
      modalWindow.addEventListener('click', modalWindowClickHandler);

      // Доступность для модалк
      modalWindow.removeAttribute('aria-hidden');

      window.focusTrap.setFocusTrap(modalWindow);

    }

    function closeModal() {
      modalWindow.classList.add('modal-hidden');

      modalOverlay.classList.remove('this-show');

      // Вешаю отсчёт времени для отработки CSS анимации
      setTimeout(function () {
        modalOverlay.style.display = 'none';

        body.classList.remove('modal-open');
        body.style.paddingRight = '0';

        modalWindow.style.display = 'none';
        modalWindow.style.paddingRight = '0';
      }, TRANSITION_TIME * 1000);

      // Доступность для модалк
      modalWindow.setAttribute('aria-hidden', 'true');

      // Убираю все события после закрытия модалки
      if (buttonModalHide) {
        buttonModalHide.forEach(function (current) {
          current.removeEventListener('click', closeModal);
        });
      }
      modalWindow.removeEventListener('click', modalWindowClickHandler);
      document.removeEventListener('keydown', documentKeyDownHandler);

      window.focusTrap.setFocusTrap(modalWindow);
    }

    function documentKeyDownHandler(evt) {
      if (evt.key === window.utils.keyEscape && !evt.target.matches('input, textarea, select')) {
        closeModal();
        // console.log(evt);
      }
    }

    function modalWindowClickHandler(evt) {
      if (evt.target === modalWindow) {
        closeModal();
      }
    }

    buttonModalShow.addEventListener('click', function () {
      openModal();

      // После клика по кнопке открытия модалки
      // добавляю событие клика по кнопке закрытия
      if (buttonModalHide) {
        buttonModalHide.forEach(function (current) {
          current.addEventListener('click', closeModal);
        });
      }
    });

    buttonModalShow.addEventListener('keydown', function (evt) {
      if (evt.key === window.utils.keyEnter && !buttonModalShow.matches('button, a')) {
        openModal();
        if (buttonModalHide) {
          buttonModalHide.forEach(function (current) {
            current.addEventListener('click', closeModal);
          });
        }
      }
    });

    if (modalWindow.classList.contains('open')) {
      openModal();
    }
  };


  window.modal = {
    alexModal: alexModal
  }

})();

// Анимация фокуса на input, доработки
(function () {

  window.addEventListener('load', function () {

    let inputFocusWrap = document.querySelectorAll('.input-focus');

    function inputBlurHandler(evt, index) {
      if (evt.target && evt.target.matches('input, textarea') && evt.target.value !== '') {
        inputFocusWrap[index].classList.add('active');
      } else {
        inputFocusWrap[index].classList.remove('active');
      }
    }

    inputFocusWrap.forEach(function (current, index) {
      let inputFocus = current.querySelector('input, textarea');

      inputFocus.addEventListener('blur', function (evt) {
        inputBlurHandler(evt, index);
      });

      inputFocus.dispatchEvent(new Event('blur'));
    });
  });

})();

// Основное меню сайта
(function () {
  const TRANSITION_TIME = 900;

  let
    menuButton = document.querySelector('.js-menu'),
    menuWindow = document.querySelector(menuButton.dataset.id),
    menuCloseButton = menuWindow.querySelector('.js-mapsite-close');

  function openWindow() {
    document.body.style.paddingRight = window.utils.getScrollbarWidth() + 'px';

    document.body.classList.add('body-overflow');

    menuWindow.setAttribute('aria-hidden', 'false');
    menuWindow.style.display = 'block';

    window.focusTrap.setFocusTrap(menuWindow);

    setTimeout(function () {
      menuWindow.classList.remove('my-hidden');
    }, 100);

    menuCloseButton.addEventListener('click', closeWindow);
    menuCloseButton.addEventListener('keydown', buttonKeyDownHandler);
    document.addEventListener('keydown', documentKeyDownHandler);
  }

  function documentKeyDownHandler(evt) {
    if (evt.key === window.utils.keyEscape) {
      closeWindow();
    }
  }

  function buttonKeyDownHandler(evt) {
    if (evt.key === window.utils.keyEnter) {
      closeWindow();
    }
  }

  function closeWindow() {
    document.body.style.paddingRight = '0';

    document.body.classList.remove('body-overflow');
    menuWindow.classList.add('my-hidden');

    menuWindow.setAttribute('aria-hidden', 'true');

    window.focusTrap.setFocusTrap(menuWindow);

    setTimeout(function () {
      menuWindow.style.display = 'none';
    }, TRANSITION_TIME);

    document.removeEventListener('keydown', documentKeyDownHandler);
    menuCloseButton.removeEventListener('click', closeWindow);
    menuCloseButton.removeEventListener('keydown', closeWindow);
  }

  menuButton.addEventListener('click', openWindow);

})();

// Инициализация Слайдеров
(function () {
  [].forEach.call(document.querySelectorAll('.js-slider-parent'), function (container) {
    let sliderElement = container.querySelector('.js-slider');

    let slider = tns({
      container: sliderElement,
      items: +sliderElement.dataset.items || 1,
      center: sliderElement.dataset.center || false,
      loop: !sliderElement.dataset.loop,
      startIndex: (sliderElement.dataset.reverse) ? sliderElement.childElementCount - 1 : 0,
      mouseDrag: true,
      rewind: sliderElement.dataset.rewind || false,
      autoWidth: sliderElement.dataset.autoWidth || false,
      autoplay: sliderElement.dataset.autoPlay || false,
      autoplayDirection: sliderElement.dataset.autoplayDirection || "forward",
      autoplayButtonOutput: false,
      speed: 1000,
      autoHeight: !sliderElement.dataset.autoHeight,
      controlsText: ['<span class="tiny-arrow tiny-arrow--left"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 18" xml:space="preserve"><g><g  transform="rotate(0 22.052 8.656)"><g transform="matrix(-1 0 0 1 44 1)"><g><g><path class="st0" d="M43 8.1H.9"/><path class="st0" d="M34.9 16.1l8.1-8"/><path class="st0" d="M43 8.1L34.9 0"/></g></g></g></g></g></svg></span>', '<span class="tiny-arrow tiny-arrow--right"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 18" xml:space="preserve"><g><g  transform="rotate(-180 22.052 8.656)"><g transform="matrix(-1 0 0 1 44 0)"><g><g><path class="st0" d="M43 8.1H.9"/><path class="st0" d="M34.9 16.1l8.1-8"/><path class="st0" d="M43 8.1L34.9 0"/></g></g></g></g></g></svg></span>'],
      responsive: {
        320: {
          edgePadding: 0,
          gutter: 0,
          items: 1
        },
        768: {
          edgePadding: +sliderElement.dataset.edgePadding || false,
          gutter: +sliderElement.dataset.gutter || 0,
          items: +sliderElement.dataset.items || 1
        }
      }
    });

    let setInfoSlider = function (e) {
      let
        numberDOMElement = container.querySelector('.js-tiny-info-numbers') || false,
        textDOMElement = container.querySelector('.js-tiny-info-text') || false,
        contentBlock = container.querySelectorAll('.js-slider-content'),
        contentBlockActive = container.querySelector('.js-slider-content.active') || false;

      contentBlock = (contentBlock.length !== 0) ? contentBlock : false;

      // Перерасчёт индекса активного элемента слайдера, если отсчёт начинается с конца
      let currentIndexDisplay = (sliderElement.dataset.reverse) ? (e.displayIndex - (e.pages + 1)) * -1 : e.displayIndex;

      if (contentBlock) {
        contentBlockActive.classList.remove('active');
        contentBlock[e.displayIndex - 1].classList.add('active');
      }

      if (numberDOMElement) {
        numberDOMElement.textContent = window.utils.setZeroFirst(currentIndexDisplay) + ' / ' + window.utils.setZeroFirst(e.pages);
      }
      if (textDOMElement) {
        textDOMElement.textContent = e.slideItems[e.displayIndex].dataset.info;
      }
    };

    setInfoSlider(slider.getInfo());

    slider.events.on('transitionStart', setInfoSlider);
  });

})();

// Календарь для регистрации (в разметке два инпута)
(function () {
  let inputDate = $('.input-daterange');
  if (inputDate.length) {
    !function (a) {
      a.fn.datepicker.dates["uz-latn"] = {
        days: ["Yakshanba", "Dushanba", "Seshanba", "Chorshanba", "Payshanba", "Juma", "Shanba"],
        daysShort: ["Yak", "Du", "Se", "Chor", "Pay", "Ju", "Sha"],
        daysMin: ["Ya", "Du", "Se", "Cho", "Pa", "Ju", "Sha"],
        months: ["Yanvar", "Fevral", "Mart", "Aprel", "May", "Iyun", "Iyul", "Avgust", "Sentabr", "Oktabr", "Noyabr", "Dekabr"],
        monthsShort: ["Yan", "Fev", "Mar", "Apr", "May", "Iyn", "Iyl", "Avg", "Sen", "Okt", "Noy", "Dek"],
        today: "Bugun",
        clear: "O'chirish",
        format: "dd.mm.yyyy",
        weekStart: 1,
        monthsTitle: "Oylar"
      }
    }(jQuery);
    !function (a) {
      a.fn.datepicker.dates.ru = {
        days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
        daysShort: ["Вск", "Пнд", "Втр", "Срд", "Чтв", "Птн", "Суб"],
        daysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
        monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
        today: "Сегодня",
        clear: "Очистить",
        format: "dd.mm.yyyy",
        weekStart: 1,
        monthsTitle: "Месяцы"
      }
    }(jQuery);

    inputDate.datepicker({
      format: "dd MM yyyy",
      todayHighlight: true,
      startDate: "today",
      language: currentLang,
      datesDisabled: dateDisabled,
      autoclose: true
    });
  }

  let changeDateHandler = function (e) {
    document.querySelector(e.target.dataset.hidden).value = moment(e.date).format('DD.MM.YYYY');
  };

  $('#dateIn').on('changeDate', changeDateHandler);
  $('#dateOut').on('changeDate', changeDateHandler);
})();

// Переключение табов
(function () {
  let tabWork = function (tabParent) {
    let
      tabArray = window.utils.getArrayFrom(tabParent.querySelector('.js-tab-item').children),
      tabTargetArray = window.utils.getArrayFrom(tabParent.querySelector('.js-tab-target').children),
      tabActive = tabParent.querySelector('.js-tab-item .active');

    let tabIndicator = window.utils.createDivWithClass('tab-indicator');
    tabParent.querySelector('.js-tab-item').appendChild(tabIndicator);

    let calculateYAxisIndicator = function () {
      tabIndicator.style.transform = 'translateY(' + ((tabActive.offsetTop + (tabActive.clientHeight / 2)) - (tabIndicator.clientHeight / 2)) + 'px)';
    };
    calculateYAxisIndicator();

    function toggleTabEvent(current, index) {
      let activeArray = Array.from(tabParent.querySelectorAll('.active'));

      activeArray.forEach(function (activeCurrent) {
        activeCurrent.classList.remove('active');
      });

      current.classList.add('active');
      tabTargetArray[index].classList.add('active');

      tabActive = current;
      calculateYAxisIndicator();
    }

    tabArray.forEach(function (current, index) {
      current.addEventListener('click', function () {
        toggleTabEvent(current, index);
      });

      current.addEventListener('keydown', function (evt) {
        if (evt.key === window.utils.keyEnter) {
          toggleTabEvent(current, index);
        }
      });
    });
  };

  window.tab = {
    tabWork: tabWork
  }

})();

// Переключатель для появления формы в футере
(function () {
  let
    toggleParent = document.querySelector('.js-toggle-parent'),
    toggleStart = toggleParent.querySelector('.js-toggle-start'),
    toggleButtonClose = toggleParent.querySelector('.js-toggle-close');

  function toggleOpen() {
    toggleParent.classList.add('active');
    toggleButtonClose.addEventListener('click', toggleButtonCloseClickHandler);
    toggleButtonClose.addEventListener('keydown', toggleButtonKeyDownClickHandler);
  }

  function toggleClose() {
    toggleParent.classList.remove('active');

    toggleButtonClose.removeEventListener('click', toggleButtonCloseClickHandler);
    toggleButtonClose.removeEventListener('keydown', toggleButtonKeyDownClickHandler);
  }

  function toggleButtonCloseClickHandler() {
    toggleClose();
  }

  function toggleButtonKeyDownClickHandler(evt) {
    if (evt.key === window.utils.keyEnter) {
      toggleClose();
    }
  }

  toggleStart.addEventListener('click', function () {
    toggleOpen();
  });

  toggleStart.addEventListener('keydown', function (evt) {
    if (evt.key === window.utils.keyEnter) {
      toggleOpen();
    }
  })

})();

// Плавный скроллинг к элементу
(function () {
  let scrollButton = document.querySelectorAll('.js-scroll-to');

  scrollButton.forEach(function (current) {
    current.addEventListener('click', function () {
      let
        idElemntToScroll = current.dataset.id || document.body, // {String|HTMLElement} data-id — ID элемента для прокрутки || по умолчанию элемента body
        dataDuration = +current.dataset.duration || 1500; // {Number} data-duration — длительность прокрутки || по умолчанию 1500

      window.utils.scrollPageTo(idElemntToScroll, dataDuration).then();
    })
  });

})();

// Прелоадер
(function () {
  let preload = document.querySelector('.preload');

  setTimeout(function () {
    preload.classList.remove('preload--ready');
  }, 200);

  window.addEventListener('load', function () {
    preload.classList.add('active');

    setTimeout(function () {
      preload.style.display = 'none';
    }, 1000);
  });

})();

// Суммирование чисел с инпутов - узкоспециализирован*****
(function () {
  let amountWrap = document.querySelectorAll('.js-amount');
  if (amountWrap.length > 0) {
    amountWrap.forEach(function (current) {
      let
        amountCollectButton = current.querySelector('.js-amount-collect'),
        amountCollectParent = current.querySelector('.js-amount-parent'),
        amountGuestInput = current.querySelector('.js-amount-guest');

      if (amountCollectButton && amountCollectParent && amountGuestInput) {
        function setAmountInputValue() {
          amountGuestInput.value = window.utils.collectNumberFromInputs(amountCollectParent.querySelectorAll('input'));
        }

        amountCollectButton.addEventListener('click', setAmountInputValue);
        amountCollectButton.addEventListener('keyDown', setAmountInputValue);
      }
    });
  }

})();

// Тултип
(function () {
  let tooltipElement = document.querySelectorAll('.js-tooltip');

  tooltipElement.forEach(function (current) {
    if (current) {
      let
        tooltipBox = document.querySelector(current.dataset.id),
        tooltipCloseButton = tooltipBox.querySelector('.js-tooltip-close');

      function documentClickHandler(evt) {
        let target = evt.target;

        if (target.closest('#' + tooltipBox.id) !== tooltipBox) {
          closeTooltip();
        }
      }

      function documentKeyDownHandler(evt) {
        if (evt.key === window.utils.keyEscape) {
          closeTooltip();
        }
      }

      function tooltipCloseButtonKeyDownHandler(evt) {
        if (evt.key === window.utils.keyEnter) {
          closeTooltip();
        }
      }

      function openTooltip(evt) {
        evt.preventDefault();

        tooltipBox.style.display = 'block';
        current.setAttribute('aria-expanded', 'true');

        document.addEventListener('click', documentClickHandler, true);
        tooltipCloseButton.addEventListener('click', closeTooltip);
        tooltipCloseButton.addEventListener('keyDown', tooltipCloseButtonKeyDownHandler);

        document.addEventListener('keydown', documentKeyDownHandler);
      }

      function closeTooltip() {
        tooltipBox.style.display = 'none';
        current.setAttribute('aria-expanded', 'false');

        document.removeEventListener('click', documentClickHandler, true);
        document.removeEventListener('keydown', documentKeyDownHandler);
        tooltipCloseButton.removeEventListener('click', closeTooltip);
        tooltipCloseButton.removeEventListener('keyDown', tooltipCloseButtonKeyDownHandler);
      }

      current.addEventListener('click', openTooltip);

      current.addEventListener('keydown', function (evt) {
        if (evt.key === window.utils.keyEnter) {
          openTooltip(evt);
        }
      });
    }
  });
})();

//  Раскрывает выпадающий блок
(function () {
  /**
   * @param  {Object} path             Путь до елемента с которого всё начинается (стрелка)
   * @param  {String} parent_name      Класс родителя откуда от места начала (".exampleClass")
   * @param  {String} children_in      Класс скрытого блока (".exampleClass")
   * @param  {String | Number} duration_h  Время исполнения анимации (slow|normal|fast)
   * @param  {Boolean} hidden_path     Скрывать path элемент (true) или нет (false)
   * @param  {Number} a_time           Задаёт задержку раскрытия в милисекундах
   * @return {undefined}
   */
  function wiyzjalka(path, parent_name, children_in, duration_h, hidden_path, a_time) {
    var a_time = (!a_time) ? 0 : a_time;
    path.each(function () {
      var thisHand = $(this);

      if ($(this).parents(parent_name).find(children_in).find(".js-active").length > 0 || $(this).hasClass('js-open')) {
        $(this).parents(parent_name).addClass("js-open");
        $(this).parents(parent_name).find(children_in).stop().delay(a_time).slideDown(duration_h);
        if ("true" === $(this).parents(parent_name).find(children_in).attr('aria-hidden')) {
          $(this).parents(parent_name).find(children_in).attr('aria-hidden', 'false');
        } else {
          $(this).parents(parent_name).find(children_in).attr('aria-hidden', 'true');
        }
      }

      function openPandora() {
        if ($(children_in).find('.hide-box').length) {
          var dMSec = (duration_h == "slow") ? 600
            : (duration_h == "normal") ? 400
              : (duration_h == "fast") ? 200 : 0
          setTimeout(function () {
            toolboxSetClass($('.hide-box'));
          }, dMSec + a_time);
        }
        if (hidden_path) {
          thisHand.hide();
        }
        path.parents(parent_name).find(children_in).stop(true, false).slideUp(duration_h);
        path.parents(parent_name).removeClass("js-open");
        path.parents(parent_name).removeClass("js-active");
        if (thisHand.parents(parent_name).find(children_in).is(children_in)) {
          if (thisHand.parents(parent_name).find(children_in).is(":visible")) {
            thisHand.parents(parent_name).removeClass("js-open");
            thisHand.parents(parent_name).find(children_in).stop().slideUp(duration_h, function () {
              // console.log(thisHand.css());
              thisHand.css("height", "auto");
            });
            if (thisHand.parents(parent_name).find(children_in).attr('aria-hidden') === "true") {
              thisHand.parents(parent_name).find(children_in).attr('aria-hidden', 'false');
            } else {
              thisHand.parents(parent_name).find(children_in).attr('aria-hidden', 'true');
            }
          } else {
            if (thisHand.parents(parent_name).find(children_in).attr('aria-hidden') === "true") {
              thisHand.parents(parent_name).find(children_in).attr('aria-hidden', 'false');
            } else {
              thisHand.parents(parent_name).find(children_in).attr('aria-hidden', 'true');
            }
            thisHand.parents(parent_name).addClass("js-open");
            thisHand.parents(parent_name).find(children_in).stop().delay(a_time).slideDown(duration_h);
          }
        }
      }

      thisHand.bind("click", openPandora);
      thisHand.on("keydown", function (e) {
        if (e.keyCode === 13) {
          openPandora()
        }
      });
    });
  }

  window.collapse = {
    wiyzjalka: wiyzjalka
  }
})();

(function () {
  // Let the document know when the mouse is being used
  document.body.addEventListener('mousedown', function () {
    document.body.classList.add('using-mouse');
  });

  // Re-enable focus styling when Tab is pressed
  document.body.addEventListener('keydown', function (event) {
    if (event.keyCode === 9) {
      document.body.classList.remove('using-mouse');
    }
  });
})();

//  Дефолтный поток
(function () {
  AOS.init({disable: 'mobile'});

  if (window.matchMedia("(min-width: 768px)").matches) {
    document.querySelectorAll('.js-transition-parent').forEach(function (current) {
      window.utils.setTransitionForChildren(current);
    });
  }

  document.querySelectorAll('.js-modal').forEach(function (current) {
    window.modal.alexModal(current);
  });

  document.querySelectorAll('.js-tab-parent').forEach(function (current) {
    window.tab.tabWork(current);
  });

  if ($('.js-pandora-parent').length) {
    window.collapse.wiyzjalka($('.js-pandora-hand'), '.js-pandora-parent', '.js-pandora-box', 'normal', false, 0);
  }

})();

// Инициализация карты
function initMap() {
  const ZOOM_VALUE = 14;
  var ICON_IMAGE_SVG = "/common/images/pin.svg";
  const COORDS = {lat: 41.269495, lng: 69.211229};
  const map = new google.maps.Map(document.getElementById('map'), {
    zoom: ZOOM_VALUE,
    center: COORDS,
    disableDefaultUI: true,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_CENTER
    },
    styles: [
      {
        "featureType": "road",
        "stylers": [
          {"color": "#ffffff"}
        ]
      },
      {
        "featureType": "landscape",
        "stylers": [
          {"color": "#f5f8fc"}
        ]
      },
      {
        "featureType": "poi",
        "stylers": [
          {"color": "#f0f0f0"}
        ]
      },
      {
        "featureType": "water",
        "stylers": [
          {"color": "#c3e7ff"}
        ]
      },
      {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
          {"color": "#134668"},
        ]
      },
      {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
          {"color": "#ffffff"},
        ]
      },
    ],
  });

  const marker = new google.maps.Marker({
    position: COORDS,
    map: map,
    icon: {
      url: ICON_IMAGE_SVG,
      size: new google.maps.Size(100, 100),
      scaledSize: new google.maps.Size(100, 100)
    }
  });
}

(function () {
  $(window).on('load', function () {
    if ($('body').hasClass('contact-page')) {
      $('head').append('<script async defer src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBuQVk5FCfInktoUBcUSaG0bRoPQbnMBfg&callback=initMap"><\/script>');
    }
  });
})();

// табы
(function () {
  $(document).ready(function () {
    const body = $(`body`);
    const tabButton = body.find(`button[data-tab], a[data-tab]`);
    const tabElem = body.find(`[data-tab]`).not(`button`);

    function toggleActiveTab(id) {
      tabButton.removeClass(`active`);
      tabElem.removeClass(`active`);
      body.find(`[data-tab="${id}"]`).addClass(`active`);
      body.find(`[data-image]`).removeClass(`active`);
      body.find(`[data-tab="${id}"]`).find(`[data-image]`).eq(0).click();
    }

    $(document).on(`click`, `button[data-tab], a[data-tab]`, function () {
      const current = $(this);
      const id = current.data(`tab`);
      toggleActiveTab(id);
    });
  });
})();

// Открытие/закрытие бокового меню
(function () {
  $(document).ready(function () {
    const body = $(`body`);
    const sidebarButton = body.find(`button[data-sidebar], a[data-sidebar]`);
    const sidebarElem = body.find(`[data-sidebar]`).not(`button`);

    function toggleActiveTab(id) {
      body.find(`[data-sidebar="${id}"]`).toggleClass(`open`);
    }

    $(document).on(`click`, `button[data-sidebar], a[data-sidebar]`, function () {
      const current = $(this);
      const id = current.data(`sidebar`);
      toggleActiveTab(id);
    });

    if (window.matchMedia("(max-width: 1000px)").matches) {
      sidebarButton.removeClass(`open`);
      sidebarElem.removeClass(`open`);
    }

    if (window.matchMedia("(max-width: 768px)").matches) {
      $(document).on(`click`, `[data-image]`, function () {
        body.find(`[data-sidebar]`).removeClass(`open`);
      });
    }
  });
})();

// панорама 360
(function () {
  if ($('body').hasClass('online-360')) {
    const panorama = $(`.panorama`);

    $(window).on(`load`, function () {
      const item = $(`.panorama__subcategory-link`);
      const viewer = pannellum.viewer('panorama', {
        "default": {
          "firstScene": "scene-1",
          "autoLoad": true
        },
        "scenes": {
          "scene-1": {
            "type": "equirectangular",
            "yaw": -110,
            "panorama": $(`[data-scene="1"]`).data(`image`),
            "hotSpots": [
              {
                "pitch": -1,
                "yaw": -123.2,
                "type": "scene",
                "text": $(`[data-scene="2"]`).text(),
                "sceneId": "scene-2"
              },
              {
                "pitch": -6.5,
                "yaw": -196.5,
                "type": "scene",
                "text": $(`[data-scene="3"]`).text(),
                "sceneId": "scene-3"
              }
            ]
          },
          "scene-2": {
            "type": "equirectangular",
            "yaw": -80,
            "panorama": $(`[data-scene="2"]`).data(`image`),
            "hotSpots": [
              {
                "pitch": -2.2,
                "yaw": 98.5,
                "type": "scene",
                "text": $(`[data-scene="1"]`).text(),
                "sceneId": "scene-1"
              },
              {
                "pitch": -1.5,
                "yaw": -85,
                "type": "scene",
                "text": $(`[data-scene="5"]`).text(),
                "sceneId": "scene-5"
              },
              {
                "pitch": -1.7,
                "yaw": 114.5,
                "type": "scene",
                "text": $(`[data-scene="10"]`).text(),
                "sceneId": "scene-10"
              }
            ]
          },
          "scene-3": {
            "type": "equirectangular",
            "yaw": -130,
            "panorama": $(`[data-scene="3"]`).data(`image`),
            "hotSpots": [
              {
                "pitch": -8,
                "yaw": 215,
                "type": "scene",
                "text": $(`[data-scene="4"]`).text(),
                "sceneId": "scene-4"
              },
              {
                "pitch": -8,
                "yaw": -60,
                "type": "scene",
                "text": $(`[data-scene="10"]`).text(),
                "sceneId": "scene-10"
              },
              {
                "pitch": -8,
                "yaw": 96,
                "type": "scene",
                "text": $(`[data-scene="13"]`).text(),
                "sceneId": "scene-13"
              },
              {
                "pitch": -8,
                "yaw": 20,
                "type": "scene",
                "text": $(`[data-scene="1"]`).text(),
                "sceneId": "scene-1"
              }
            ]
          },
          "scene-4": {
            "type": "equirectangular",
            "yaw": 170,
            "panorama": $(`[data-scene="4"]`).data(`image`),
            "hotSpots": [
              {
                "pitch": 1.6,
                "yaw": 125.5,
                "type": "scene",
                "text": $(`[data-scene="11"]`).text(),
                "sceneId": "scene-11"
              },
              {
                "pitch": 2,
                "yaw": -130,
                "type": "scene",
                "text": $(`[data-scene="12"]`).text(),
                "sceneId": "scene-12"
              },
              {
                "pitch": -3,
                "yaw": 97.8,
                "type": "scene",
                "text": $(`[data-scene="3"]`).text(),
                "sceneId": "scene-3"
              },
              {
                "pitch": -4,
                "yaw": 180.5,
                "type": "scene",
                "text": $(`[data-scene="13"]`).text(),
                "sceneId": "scene-13"
              }
            ]
          },
          "scene-5": {
            "type": "equirectangular",
            "yaw": -80,
            "panorama": $(`[data-scene="5"]`).data(`image`),
            "hotSpots": [
              {
                "pitch": -1.3,
                "yaw": 261,
                "type": "scene",
                "text": $(`[data-scene="6"]`).text(),
                "sceneId": "scene-6"
              },
              {
                "pitch": -3.5,
                "yaw": 8,
                "type": "scene",
                "text": $(`[data-scene="2"]`).text(),
                "sceneId": "scene-2"
              }
            ]
          },
          "scene-6": {
            "type": "equirectangular",
            "yaw": -110,
            "hfov": 250,
            "panorama": $(`[data-scene="6"]`).data(`image`),
            "hotSpots": [
              {
                "pitch": 27,
                "yaw": -120,
                "type": "scene",
                "text": $(`[data-scene="7"]`).text(),
                "sceneId": "scene-7"
              },
              {
                "pitch": 26,
                "yaw": -110,
                "type": "scene",
                "text": $(`[data-scene="8"]`).text(),
                "sceneId": "scene-8"
              },
              {
                "pitch": 1,
                "yaw": -119,
                "type": "scene",
                "text": $(`[data-scene="9"]`).text(),
                "sceneId": "scene-9"
              },
              {
                "pitch": -3.5,
                "yaw": 131.7,
                "type": "scene",
                "text": $(`[data-scene="5"]`).text(),
                "sceneId": "scene-5"
              }
            ]
          },
          "scene-7": {
            "type": "equirectangular",
            "yaw": 0,
            "panorama": $(`[data-scene="7"]`).data(`image`),
            "hotSpots": [
              {
                "pitch": 2,
                "yaw": 106,
                "type": "scene",
                "text": $(`[data-scene="6"]`).text(),
                "sceneId": "scene-6"
              }
            ]
          },
          "scene-8": {
            "type": "equirectangular",
            "yaw": 0,
            "panorama": $(`[data-scene="8"]`).data(`image`),
            "hotSpots": [
              {
                "pitch": 2,
                "yaw": 120,
                "type": "scene",
                "text": $(`[data-scene="6"]`).text(),
                "sceneId": "scene-6"
              }
            ]
          },
          "scene-9": {
            "type": "equirectangular",
            "yaw": 180,
            "panorama": $(`[data-scene="9"]`).data(`image`),
            "hotSpots": [
              {
                "pitch": 1,
                "yaw": 28,
                "type": "scene",
                "text": $(`[data-scene="6"]`).text(),
                "sceneId": "scene-6"
              }
            ]
          },
          "scene-10": {
            "type": "equirectangular",
            "yaw": 0,
            "panorama": $(`[data-scene="10"]`).data(`image`),
            "hotSpots": [
              {
                "pitch": 1.6,
                "yaw": 3,
                "type": "scene",
                "text": $(`[data-scene="3"]`).text(),
                "sceneId": "scene-3"
              },
              {
                "pitch": -3,
                "yaw": 196,
                "type": "scene",
                "text": $(`[data-scene="2"]`).text(),
                "sceneId": "scene-2"
              }
            ]
          },
          "scene-11": {
            "type": "equirectangular",
            "yaw": 0,
            "panorama": $(`[data-scene="11"]`).data(`image`),
            "hotSpots": [
              {
                "pitch": 1.6,
                "yaw": -122,
                "type": "scene",
                "text": $(`[data-scene="4"]`).text(),
                "sceneId": "scene-4"
              }
            ]
          },
          "scene-12": {
            "type": "equirectangular",
            "yaw": 0,
            "panorama": $(`[data-scene="12"]`).data(`image`),
            "hotSpots": [
              {
                "pitch": 1.6,
                "yaw": -147,
                "type": "scene",
                "text": $(`[data-scene="4"]`).text(),
                "sceneId": "scene-4"
              }
            ]
          },
          "scene-13": {
            "type": "equirectangular",
            "yaw": -190,
            "panorama": $(`[data-scene="13"]`).data(`image`),
            "hotSpots": [
              {
                "pitch": -5,
                "yaw": 10,
                "type": "scene",
                "text": $(`[data-scene="4"]`).text(),
                "sceneId": "scene-4"
              },
              {
                "pitch": -3,
                "yaw": -180,
                "type": "scene",
                "text": $(`[data-scene="3"]`).text(),
                "sceneId": "scene-3"
              }
            ]
          }
        }
      });

      viewer.on('scenechange', function () {
        const sceneId = viewer.getScene();
        const allSceneLink = $(`[data-scene]`);
        const sceneLink = $(`[data-scene=${sceneId.split('-')[1]}]`);
        const sceneCat = sceneLink.parents(`[data-tab]`).data(`tab`);

        allSceneLink.removeClass(`active`);
        $(`[data-tab]`).removeClass(`active`);
        sceneLink.addClass(`active`);
        $(`[data-tab=${sceneCat}]`).addClass(`active`);
      });

      // data-image
      $(document).on(`click`, `[data-image]`, function () {
        const current = $(this);
        const id = current.data(`image`);
        const link = current.data(`link`);
        $('[data-image]').removeClass('active');
        current.addClass('active');

        $('.panorama__link').attr('href', link);
        viewer.loadScene(`scene-${current.data(`scene`)}`);
      });
    });
  }
})();

// карта санатория
(function () {
  if ($('body').find('[data-hover]').length > 0) {
    if (window.matchMedia("(min-width: 816px)").matches) {
      $('a.medical-center-control-list__text').click(function (e) {
        e.preventDefault();
      });

      $('[data-hover]').hover(function () {
        const id = $(this).data('hover');

        if (($('[data-hover]').hasClass('active'))) {
          $(`[data-hover]`).removeClass('active');
        }

        $(`[data-hover="${id}"]`).addClass('active');

        const offset = $('.online-map__nav-item.active')[0].offsetTop;
        $('.tab-indicator').css({transform: `translateY(${offset + 21}px)`});
      });
    }
  }
})();

// Форма регистрации
(function () {
  if ($('input[type="file"]').length > 0) {
    $('input[type="file"]').change(function () {
      if ($(this)[0].files.length > 0) {
        const fileName = $(this)[0].files[0].name;
        $(this).next().text(fileName);
      } else {
        $(this).next().text('');
      }
    });
  }
})();
